import {
  UpdateTradeFlow,
  useUpdateAccessControlTradeFlowMutation,
  useUpdateTradeFlowMutation,
} from "../store/apiSlices/tradeFlow";
import { DealsGridContext } from "../types/DealTracker";

export function useTradeFlowUpdater({
  permission,
  tableId,
  parentId,
}: {
  permission: DealsGridContext["permission"];
  tableId: number;
  parentId: number;
}) {
  const [updateTradeFlow] = useUpdateTradeFlowMutation();
  const [updateSharedTradeFlow] = useUpdateAccessControlTradeFlowMutation();

  return async (payload: UpdateTradeFlow) => {
    if (permission === "owner") {
      return updateTradeFlow({
        ...payload,
        table_id: tableId,
      }).unwrap();
    }

    // editor / viewer → shared API
    return updateSharedTradeFlow({
      ...payload,
      table_id: tableId,
      parent_id: parentId,
    }).unwrap();
  };
}
